import './fietssnelweg-popup.styl';

function FietssnelwegPopup({ feature }) {
  const { FSW_NUMMER, BEFIETSBAAR } = feature?.properties || {};

  return (
    <div className="fietssnelweg-popup">
      <div className="fietssnelweg-popup__title">
        {`Fietssnelweg ${FSW_NUMMER}`}
      </div>
      <div className="fietssnelweg-popup__content">
        {`${BEFIETSBAAR === 1 ? 'Fietsbaar' : 'Gepland'}`}
      </div>
    </div>
  );
}

export default FietssnelwegPopup;